import React from 'react';
import { useEffect, useState } from 'react';
import useGetCampaignsData from '../../../../../lib/useGetCampaignsData';
// import './fundraisersPanel.scss';
import {
	Container,
	Row,
	Card,
	Col,
	Button,
	Progress,
	CardText
} from 'reactstrap';
import { PriceTag } from '../../utils';

const FundraisersPanel = ({ featuredFundraisers, tenantConfig, session , activeTab}) => {
	const numberOfTilesToShow = 3;
	const [limit, setLimit] = useState(numberOfTilesToShow);
	const [featuredFundraisersData, setFeaturedFundraisersData] = useState();
	const [hasFundraisersWithData, setHasFundraisersWithData] = useState(false);

	// Fetch other fields (raised_amount_in_inr, creator_name, permalink, image) of featuredFundraisers
	let campaignsData = '';
	if (featuredFundraisers) {
		let { campaigns, error } = useGetCampaignsData(
			featuredFundraisers.map(campaign => {
				return campaign.id;
			})
		);
		campaignsData = campaigns;
	}

	useEffect(() => {
		// Merge other details to featuredFundraisers
		if (campaignsData) {
			let mergedData = [];
			for (let i = 0; i < featuredFundraisers.length; i++) {
				mergedData.push({
					...featuredFundraisers[i],
					...campaignsData.find(
						campaigns => campaigns.id === featuredFundraisers[i].id
					)
				});
			}
			setFeaturedFundraisersData(mergedData);
		}
	}, [campaignsData]);

	useEffect(() => {
		if (featuredFundraisersData?.length) {
			let hasFundraisers = featuredFundraisersData.filter(item => item?.slug);
			hasFundraisers.length && setHasFundraisersWithData(true);
		}
	}, [featuredFundraisersData]);

	const featuredFundraisersCard = campaigns =>
		campaigns?.map((campaign, idx) =>
			campaign?.slug ? (
				<Col className="fundrasier-card-homepage" lg="4" md="6" key={idx}>
					<a
						href={campaign.permalink}
						onClick={() => {
							const eventInfo = {
								panelName: campaign.title
							};
							if (window.eventDispatcher) {
								window.eventDispatcher.dispatchEventSync(
									'fundraiser-card',
									eventInfo,
									{ amplitude: true }
								);
							}
						}}
						style={{ textDecoration: 'none' }}
					>
						<Card className="missions-card fcm-tile">
							<div className="missions-card-img-wrap" >
								<img
									style={{ width: '100%' }}
									src={campaign.image}
									alt={campaign.title}
									loading="lazy"
								/>
							</div>
							<CardText className="missions-card-text-box ">
								<div style={{ paddingBottom: '10px' }}>
									<p className="mission-card-title" style={{ color: '#444' }}>
										<span className="darker-grey">{campaign.title}</span>
										<span className="sh w-100">
											&nbsp;by&nbsp;{campaign.creator_name}
										</span>
									</p>
								</div>
								<p style={{ color: '#444444', paddingBottom: '5px' }}>
									<PriceTag
										price={campaign.raised_amount_in_inr}
										theme={tenantConfig.theme}
										session={session}
									/>{' '}
									&nbsp;Raised
								</p>

								<div className="progress-wrapper">
									<Progress
										className="supporter-process-bar"
										value={Math.round(
											(campaign.raised_amount_in_inr /
												campaign.target_amount_in_inr) *
												100
										)}
									/>
									<p style={{ color: '#444444', paddingTop: '7px' }}>
										<span>
											<span className=" monthly-count-supporters">
												<PriceTag
													price={campaign.target_amount_in_inr}
													style={{ color: '#444444' }}
													theme={tenantConfig.theme}
													session={session}
												/>
											</span>
										</span>
										<span className=" completed-supporters-homepage">
											{campaign?.supporter_count?.toLocaleString('en-in')}
										</span>
									</p>

									<p style={{ color: '#444444', paddingBottom: '5px' }}>
										<span>
											<span className=" monthly-count-supporters">Goal</span>
										</span>
										<span className=" completed-supporters-homepage">
											Supporters
										</span>
									</p>
								</div>

								<a
									href={campaign.permalink}
									onClick={() => {
										const eventInfo = {
											panelName: campaign.title
										};
										if (window.eventDispatcher) {
											window.eventDispatcher.dispatchEventSync(
												'fundraiser-card-btn',
												eventInfo,
												{ amplitude: true }
											);
										}
									}}
								>
									<Button
										color="primary"
										className="btn-full-width btn  btn-primary"
									>
										{campaign.cta}
									</Button>
								</a>
							</CardText>
						</Card>
					</a>
				</Col>
			) : null
		);

	return (
		<>
			{hasFundraisersWithData && (
				<Container
					className="panel-padding"
					style={{ marginTop: '40px', marginBottom: '40px' }}
				>
					{
						activeTab === 'fundraiser' ? null 
						: 
						<>
						<h2 className="feature-fundraisers-heading">Featured Fundraisers</h2>
						<div className="fundraiser-divider-heading"></div>
						</>
					}
					<Row className="fp-cards-container">
						{featuredFundraisersCard(featuredFundraisersData?.slice(0, limit))}
					</Row>
				</Container>
			)}
			<style>
				{`
					.completed-supporters-homepage{
						float: right;
						color: #444444 !important;
					}
				`}
			</style>
		</>
	);
};

export default FundraisersPanel;
